module.exports = __webpack_public_path__ + "static/media/top.65e08970.jpg";